import React from 'react'

export const Loader: React.FC = () => {
  return (
    <div className="text-sm text-primary mt-[20px] px-[15px] py-[21px]">Loading...</div>
  )
}
